import staffConstants from "../constants/staffConstants";
import staffService from "../services/staffService";
import alertActions from "./alertActions";
//import history from "../helpers/history";

const register = (dob, firstName, lastName, email, phoneNumber) => {
  const request = (registerApplicationUser) => {
    return {
      type: staffConstants.REGISTER_REQUEST,
      registerApplicationUser,
    };
  };
  const success = (user) => {
    return { type: staffConstants.REGISTER_SUCCESS, user };
  };
  const failure = (error) => {
    return { type: staffConstants.REGISTER_FAILURE, error };
  };

  return (dispatch) => {
    //console.log(dob, firstName, lastName, email, phoneNumber);
    dispatch(request(email));

    staffService.register(dob, firstName, lastName, email, phoneNumber).then(
      (user) => {
        dispatch(
          alertActions.success(
            "Successfully registered user.",
            staffConstants.REGISTER_SUCCESS
          )
        );
        dispatch(success(user));
        //history.push("/user");
      },
      (error) => {
        dispatch(
          alertActions.error(
            "There was an error, please try again.",
            staffConstants.REGISTER_FAILURE
          )
        );
        dispatch(failure(error));
      }
    );
  };
};

const registerAttorney = (
  dob,
  firstName,
  lastName,
  email,
  phoneNumber,
  barNumber
) => {
  const request = (registerApplicationUser) => {
    return {
      type: staffConstants.REGISTER_ATTORNEY_REQUEST,
      registerApplicationUser,
    };
  };
  const success = (user) => {
    return { type: staffConstants.REGISTER_ATTORNEY_SUCCESS, user };
  };
  const failure = (error) => {
    return { type: staffConstants.REGISTER_ATTORNEY_FAILURE, error };
  };

  return (dispatch) => {
    //console.log(dob, firstName, lastName, email, phoneNumber);
    dispatch(request(email));

    staffService
      .registerAttorney(dob, firstName, lastName, email, phoneNumber, barNumber)
      .then(
        (user) => {
          dispatch(success(user));
          dispatch(
            alertActions.success(staffConstants.REGISTER_ATTORNEY_SUCCESS)
          );
          //history.push("/user");
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };
};

const updateUserInfo = (personalInfo) => {
  const request = (personalInfo) => {
    return { type: staffConstants.UPDATE_USER_INFO_REQUEST, personalInfo };
  };
  const success = (personalInfo) => {
    return { type: staffConstants.UPDATE_USER_INFO_SUCCESS, personalInfo };
  };
  const failure = (error) => {
    return { type: staffConstants.UPDATE_USER_INFO_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(personalInfo));

    staffService.updatePersonalInfo(personalInfo).then(
      (personalInfo) => {
        dispatch(
          alertActions.success(
            "Successfully updated user.",
            staffConstants.UPDATE_USER_INFO_SUCCESS
          )
        );
        dispatch(success(personalInfo));
      },
      (error) => {
        dispatch(
          alertActions.error(
            "There was an error, please try again.",
            staffConstants.UPDATE_USER_INFO_FAILURE
          )
        );
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const updateAttorneyInfo = (personalInfo) => {
  const request = (personalInfo) => {
    return { type: staffConstants.UPDATE_ATTORNEY_INFO_REQUEST, personalInfo };
  };
  const success = (personalInfo) => {
    return { type: staffConstants.UPDATE_ATTORNEY_INFO_SUCCESS, personalInfo };
  };
  const failure = (error) => {
    return { type: staffConstants.UPDATE_ATTORNEY_INFO_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(personalInfo));

    staffService.updateAttorneyInfo(personalInfo).then(
      (personalInfo) => {
        dispatch(success(personalInfo));
        dispatch(
          alertActions.success(staffConstants.UPDATE_ATTORNEY_INFO_SUCCESS)
        );
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const passwordReset = (newPassword) => {
  const request = (newPassword) => {
    return { type: staffConstants.PASSWORD_RESET_REQUEST, newPassword };
  };
  const success = () => {
    return { type: staffConstants.PASSWORD_RESET_SUCCESS };
  };
  const failure = (error) => {
    return { type: staffConstants.PASSWORD_RESET_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request({ newPassword }));

    staffService.resetPassword(newPassword).then(
      () => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const userActions = {
  register,
  registerAttorney,
  updateUserInfo,
  passwordReset,
  updateAttorneyInfo,
};

export default userActions;
